import { SAMPLE_LOADING_TABLES_LOADING, SAMPLE_LOADING_TABLES_LOADED, SAMPLE_LOADING_TABLES_ERROR, SAMPLE_LOADING_TABLES_CREATED, SAMPLE_LOADING_TABLES_UPDATED, SAMPLE_LOADING_TABLES_DELETED, SAMPLE_LOADING_TABLES_SET_ACTIVE } from '../../actionTypes/sampleLoadingTables';
import initialState from './initialState';
import sampleLoadingTablesLoading from './sampleLoadingTablesLoading';
import sampleLoadingTablesLoaded from './sampleLoadingTablesLoaded';
import sampleLoadingTablesError from './sampleLoadingTablesError';
import sampleLoadingTablesCreated from './sampleLoadingTablesCreated';
import sampleLoadingTablesUpdated from './sampleLoadingTablesUpdated';
import sampleLoadingTablesDeleted from './sampleLoadingTablesDeleted';
import sampleLoadingTablesSetActive from './sampleLoadingTablesSetActive';
var sampleLoadingTablesReducer = function sampleLoadingTablesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case SAMPLE_LOADING_TABLES_LOADING:
      {
        return sampleLoadingTablesLoading(state, action);
      }
    case SAMPLE_LOADING_TABLES_LOADED:
      {
        return sampleLoadingTablesLoaded(state, action);
      }
    case SAMPLE_LOADING_TABLES_ERROR:
      {
        return sampleLoadingTablesError(state, action);
      }
    case SAMPLE_LOADING_TABLES_CREATED:
      {
        return sampleLoadingTablesCreated(state, action);
      }
    case SAMPLE_LOADING_TABLES_UPDATED:
      {
        return sampleLoadingTablesUpdated(state, action);
      }
    case SAMPLE_LOADING_TABLES_DELETED:
      {
        return sampleLoadingTablesDeleted(state, action);
      }
    case SAMPLE_LOADING_TABLES_SET_ACTIVE:
      {
        return sampleLoadingTablesSetActive(state, action);
      }
    default:
      {
        return state;
      }
  }
};
export default sampleLoadingTablesReducer;